import React from 'react';

import { IHeaderParams } from 'ag-grid-community';

import { TngBox } from '../../../../../../components/common';

interface CustomHeaderProps extends IHeaderParams {
  isSortingApplicable: boolean;
}

const CustomHeader: React.FC<CustomHeaderProps> = (props) => {
  return (
    <TngBox className="custom_header_container">
      <span role="button" style={{ cursor: 'pointer' }}>
        {props.displayName}
      </span>
    </TngBox>
  );
};

export default CustomHeader;
